import React from 'react';
import { useTranslation } from '../contexts/LanguageContext';
import { useServiceWorkerUpdate } from '../hooks/useServiceWorkerUpdate';
import '../styles/components/UpdatePrompt.css';

// Shows a non-intrusive banner when a new app version has been deployed.
// Tapping "Update" activates the waiting service worker and reloads — the
// user gets new features without reinstalling the PWA.
export default function UpdatePrompt() {
  const { t } = useTranslation();
  const { updateReady, applyUpdate } = useServiceWorkerUpdate();

  if (!updateReady) return null;

  return (
    <div className="update-prompt" role="status" aria-live="polite">
      <span className="update-prompt-text">{t('update.available')}</span>
      <button type="button" className="update-prompt-btn" onClick={applyUpdate}>
        {t('update.reload')}
      </button>
    </div>
  );
}
